import { meetingDetailPath, meetingScopeFromParams } from 'src/meetings/scope';

/** The page a review was opened from, which is where it leads back to. */
export type ReviewOrigin =
  | { kind: 'meeting'; href: string }
  | { kind: 'client-documents'; href: string; clientId: string }
  | { kind: 'household-documents'; href: string; familyId: string };

export function reviewOrigin({
  familyId,
  originMeetingId,
  originClientId,
  originFamilyId,
  clientId,
}: {
  familyId?: string;
  originMeetingId?: string;
  originClientId?: string;
  originFamilyId?: string;
  clientId: string;
}): ReviewOrigin {
  // A review opened from a meeting returns to that meeting on the route it was opened from,
  // even for a family recording that also carries a familyId.
  if (originMeetingId) {
    const scope = meetingScopeFromParams({ familyId: originFamilyId, clientId: originClientId });
    return { kind: 'meeting', href: meetingDetailPath(scope, originMeetingId) };
  }
  if (originClientId) {
    return {
      kind: 'client-documents',
      href: `/client/${originClientId}/document/add`,
      clientId: originClientId,
    };
  }
  if (familyId) {
    return { kind: 'household-documents', href: `/family/${familyId}/documents/add`, familyId };
  }
  return { kind: 'client-documents', href: `/client/${clientId}/document/add`, clientId };
}
